<template>
  <div>
    <div
      v-if="loading"
      class="col-xs-12"
      style="text-align: center"
    >
      <i class="fa fa-spinner fa-spin fa-fw fa-2x" />
    </div>

    <div
      v-if="edit && !loading"
      class="pull-right"
    >
      <div class="button-group">
        <button
          type="button"
          class="btn btn-next"
          @click="stopEdit()"
        >
          {{ trans('core.cancel') }}
        </button>
        <button
          :disabled="disableSave"
          type="button"
          class="btn btn-success"
          @click="saveEdit()"
        >
          {{
            trans('core.save') }}
        </button>
      </div>
      <br style="line-height: 0; clear:both">
    </div>

    <div
      v-if="showExam"
      class="col-xs-12"
    >
      <div class="course-details">
        <h3 style="font-weight:bold;">
          {{ trans('core.exam') }}: {{ examName }}
        </h3>
        <p>{{ trans('core.course') }}: {{ courseName }}</p>
        <p>{{ trans('core.date') }}: {{ formattedTime }}</p>
        <br>
        <p>{{ trans('subscription.exams.explanation_classrooms') }}</p>

        <form class="form-horizontal row">
          <div
            v-for="(exam, key) in orderedExams"
            class="col-xs-12"
          >
            <table class="table exam-table">
              <tr class="exam-row">
                <td>
                  <span
                    :id="'arrow-up-' + key"
                    class="fa fa-arrow-up"
                    :style="{ color: key === 0 ? 'lightgray' : 'black', cursor: key === 0 ? '' : 'pointer' }"
                    @click="moveUp(key)"
                  />
                  <span
                    :id="'arrow-down-' + key"
                    class="fa fa-arrow-down"
                    :style="{ color: key === numberOfExams - 1 ? 'lightgray' : 'black', cursor: key === numberOfExams - 1 ? '' : 'pointer' }"
                    @click="moveDown(key)"
                  />
                </td>
                <td style="text-align:right">
                  {{ trans('core.classroom') }}:
                  {{ exam.attributes.classroom_name }}
                </td>
                <td style="text-align:right">
                  {{ trans('core.capacity') }}:
                  <input
                    :id="'capacity-' + key"
                    type="number"
                    min="1"
                    :value="examCapacities[exam.id]"
                    style="width:50px;"
                    @change="changeCapacity($event.target.value, exam.id)"
                  >
                </td>
              </tr>
            </table>
          </div>
        </form>
      </div>
    </div>
    <div
      v-else-if="!edit"
      class="col-xs-12"
    >
      {{ trans('subscription.exams.no_exam_selected') }}
    </div>
  </div>
</template>

<script>
import { orderBy, pluck } from 'lodash'
import { defaultErrorMessage } from '@/helpers'
import toast from '@/services/toast'

export default {
  name: 'ExamInfo',

  props: {
    edit: { default: false },
    name: { default: null },
    date: { default: null },
    order: { default: null },
    capacities: { default: null },
    subscribable_id: { default: null },
    url_back: { default: null },
  },

  data () {
    return {
      loading: false,
      orderedExams: {},
      disableSave: false,
    }
  },

  computed: {
    exams () {
      return _.orderBy(this.$store.state.exams.exams, 'attributes.classroom_name')
    },

    formattedTime () {
      return moment(this.$store.state.exams.exam_date).format('DD-MM-YYYY')
    },

    examName () {
      return this.$store.state.exams.exam_name
    },

    courseName () {
      return this.exams[0].attributes.course
    },

    showExam () {
      return Object.keys(this.exams).length > 0
    },

    numberOfExams () {
      return this.orderedExams.length
    },

    examCapacities () {
      return this.$store.state.exams.capacities
    },
  },

  watch: {
    exams (newValue) {
      this.orderedExams = newValue
    },
  },

  mounted () {
    if (this.edit == true) {
      this.loading = true
      this.$store.dispatch('update_exam_date', this.date).then(() => {
        this.$store.dispatch('get_exam_events', this.name).then(() => {
          let order = JSON.parse(this.order)
          this.$store.dispatch('change_order_by_array', order)

          let capacities = JSON.parse(this.capacities)

          /* set capacities of events & delete events that are not part of the subscribable yet from the capacities array */
          Object.values(this.exams).forEach(exam => {
            let examId = exam.id
            let eventId = exam.attributes.event_id
            if (Object.values(order).indexOf(eventId) === -1) {
              this.$store.dispatch('unset_capacity', { examId: examId })
            } else {
              this.changeCapacity(capacities[exam.attributes.event_id], examId)
            }
          })

          let newOrder = []
          order.forEach(order => {
            let examIndex = Object.values(this.exams).findIndex(exam => exam.attributes.event_id === order)
            newOrder.push(this.exams[examIndex])
          })
          this.orderedExams = newOrder
        }).then(() => {
          this.loading = false
        }).catch(error => defaultErrorMessage(error))
      })
    }
  },

  methods: {
    moveUp (key) {
      if (key === 0) {
        return
      }
      let oldOrder = this.orderedExams
      let exam = oldOrder[key]
      oldOrder.splice(key, 1)
      oldOrder.splice(key - 1, 0, exam)
      this.orderedExams = oldOrder
      this.$store.dispatch('change_order', this.orderedExams)
    },
    moveDown (key) {
      if (key === this.numerOfExams - 1) {
        return
      }
      let oldOrder = this.orderedExams
      let exam = oldOrder[key]
      oldOrder.splice(key, 1)
      oldOrder.splice(key + 1, 0, exam)
      this.orderedExams = oldOrder
      this.$store.dispatch('change_order', this.orderedExams)
    },

    changeCapacity (value, examId) {
      this.$store.dispatch('change_capacity', { examId: examId, capacity: value })
    },

    saveEdit () {
      this.disableSave = true
      axios.put(`/exam/subscribables/` + this.subscribable_id + `/edit-classrooms`, {
        classroom_order: this.$store.state.exams.order,
        classroom_capacities: this.$store.state.exams.capacities,
      }).then(data => {
        window.location.href = data.data.redirect
      }).catch(error => {
        if (error.response.status == 422) {
          let messages = Object.values(error.response.data)
          messages.forEach(message => {
            toast.error(message)
          })
        }
        this.disableSave = false
      })
    },
    stopEdit () {
      window.location.href = this.url_back
    },
  },
}
</script>

<style scoped>
    td, th {
        padding: 5px;
    }

    .exam-table {
        border: 1px solid black;
        box-shadow: 0 0 2px 0 #25167a;
    }
</style>
